export default function getGmapAdressComponentMapping() {
  return {
    street_number: {
      field: 'adresse1',
      separator: ', ',
    },
    route: {
      field: 'adresse1',
      separator: '',
    },
    postal_code: {
      field: 'codePostal',
      separator: '',
    },
    locality: {
      field: 'ville',
      separator: '',
    },
    administrative_area_level_2: {
      field: 'departement',
      separator: '',
    },
    country: {
      field: 'pays',
      separator: '',
    },
  };
}



// WEBPACK FOOTER //
// ./src/services/general/gmapAdressComponentMapping.js